import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { IInterestSelectForm } from '@components/forms/form-types';
import { PuebloBase } from '@components/pueblo-base.component';
import { Interest } from 'pueblo-types';
import { InterestSelect } from '../interest-select/interest-select.component';

@Component({
  selector: 'interest-form',
  templateUrl: 'interest-form.component.html',
  styleUrl: 'interest-form.component.scss',
  imports: [
    InterestSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterestForm extends PuebloBase {
  private readonly fb = inject(NonNullableFormBuilder);

  protected readonly $hideTitle = input<boolean>(false);

  protected readonly interestsAdded = output<Interest[]>();
  protected readonly cancel = output();

  protected readonly form = this.fb.group({
    interests: this.fb.group<IInterestSelectForm>({
      selectedInterests: this.fb.control([]),
    }),
  });

  protected onSubmit(): void {
    if (!this.form.valid) return;

    this.httpStore.addInterests(
      (this.form.controls.interests.value.selectedInterests ?? []).map(
        (option) => option.interest.resourceName,
      ),
      {
        onSuccess: (interests) => {
          this.interestsAdded.emit(interests);
        },
      },
    );
  }
}
